import React from 'react';
import { Link } from 'react-router-dom';
import Footershape from '../../../assets/images/shapes/site-footer-shape-1.png';
import footerLogo from '../../../assets/images/resources/logo-2.png';

/** Portail organisateur (liens externes depuis le site vitrine). CRA : REACT_APP_ADMIN_PORTAL_URL */
const ADMIN_PORTAL_BASE = (
    process.env.REACT_APP_ADMIN_PORTAL_URL || "https://admin.mboapass.com"
).replace(/\/$/, "");

const Footer = () => {

  return (
    <>
    {/* Site Footer Start */}
    <footer className="site-footer-two">
        {/* <div className="site-footer__shape-1 float-bob-y">
            <img src={Footershape} alt="" />
        </div> */}
        <div className="site-footer__top">
            <div className="container">
                <div className="site-footer__top-inner">
                    <div className="site-footer__logo">
                        <Link to="/">
                            <img src={footerLogo} alt="" />
                        </Link>
                    </div>
                    <div className="site-footer__social">
                        <Link to="https://www.facebook.com/mboapass/"><i className="icon-facebook"></i></Link>
                        {/* <Link to="https://twitter.com/mboapass"><i className="icon-twitter"></i></Link> */}
                        <Link to="https://instagram.com/mboapass/"><i className="icon-instagram"></i></Link>
                        {/* <Link to="https://pinterest.com/mboapass"><i className="icon-pinterest"></i></Link> */}
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__middle">
            <div className="container">
                <div className="site-footer__middle-inner">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">FAQ</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    {/* <li><Link to="/">À propos de nous</Link></li> */}
                                    {/* <li><Link to="/">Services</Link></li> */}
                                    <li><Link to="/contact" target='_blank'>Guide Utilisateurs MBOAACCESS</Link></li>
                                    {/* <li><Link to="/">Blog Post</Link></li> */}
                                    <li><Link to="/contact" target='_blank'>Tarifs</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div className="footer-widget__column footer-widget__link">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Liens Rapides</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    {/* <li><Link to="/">À propos de nous</Link></li> */}
                                    {/* <li><Link to="/">Services</Link></li> */}
                                    <li><Link to={`${ADMIN_PORTAL_BASE}/register`} target='_blank'>Créer une billeterie</Link></li>
                                    <li><Link to="/events" target='_blank'>Ticket en ligne</Link></li>
                                    {/* <li><Link to="/">Blog Post</Link></li> */}
                                    <li><Link to="/contact" target='_blank'>Contactez-nous</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div className="footer-widget__column footer-widget__our-company">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Nos Services</h3>
                                </div>
                                <ul className="footer-widget__link-list list-unstyled">
                                    <li><Link to="/#th-blog" target='_blank'>MboaTicket</Link></li>
                                    <li><Link to="/#th-blog" target='_blank'>MboaAccess</Link></li>
                                    {/* <li><Link to="/about">Inspire and Delight Events</Link></li>
                                    <li><Link to="/about">Enchanted Gatherings</Link></li>
                                    <li><Link to="/about">Eventful Ventures</Link></li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                            <div className="footer-widget__column footer-widget__contact">
                                <div className="footer-widget__title-box">
                                    <h3 className="footer-widget__title">Contact</h3>
                                </div>
                                <div className="footer-widget__contact-inner">
                                    <ul className="footer-widget__contact-list list-unstyled">
                                        <li>
                                            <div className="icon">
                                                <span className="icon-envelop"></span>
                                            </div>
                                            <div className="text">
                                                <p><a href="mailto:contact@mboapass.com">contact@mboapass.com</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-pin"></span>
                                            </div>
                                            <div className="text">
                                                <p>Yaounde, Cameroon</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="icon-call"></span>
                                            </div>
                                            <div className="text">
                                                <p><a href="tel:+237656301229">+237 656 30 12 29</a></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="site-footer__bottom">
            <div className="container">
                <div className="site-footer__bottom-inner">
                    <p className="site-footer__bottom-text">© Mboapass 2026 | Tous Droits Réservés</p>
                    <ul className="list-unstyled site-footer__bottom-menu">
                        <li><Link to="/terms-and-conditions">Termes & Conditions</Link></li>
                        <li><Link to="/terms-and-conditions">Confidentialité</Link></li>
                        <li><Link to="/references">Références</Link></li>
                        <li><Link to="/mes-tickets">Mes Tickets</Link></li>
                        <li><Link to="/contact">Contactez-nous</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    {/* Site Footer End */}
    </>
  );
};

export default Footer;
